import React from "react";
import "./style.css";

const Contact = () => {
  return (
    <>
      {/* ---------------- Contact Info + Map Section ---------------- */}
            {/* ---------- Banner Section ---------- */}
      <section className="refund-banner">
        <div className="container">
          <h1 className="banner-title">CONTACT US</h1>

          <div className="breadcrumb">
            <span>Home</span>
            <span className="arrow">→</span>
            <span>Contact US</span>
          </div>
        </div>
      </section>
      <section className="contact-section">
        <div className="container contact-grid">
          
          {/* Left Info */}
          <div className="contact-info">

            <div className="info-box">
              <h3 className="info-title">Phone Number</h3>
              <p className="info-text">9955550979</p>
            </div>

            <div className="info-box">
              <h3 className="info-title">Email</h3>
              <p className="info-text">omeswarafintech@gmail.com</p>
            </div>

            <div className="info-box">
              <h3 className="info-title">Address</h3>
              <p className="info-text">
               WARD 13 ATITHI VISRAM GRIH BAIRGANIA <br />

City: SITAMARHI
State: Bihar
Pincode: 843313
              </p>
            </div>

          </div>

          {/* Google Map */}
          <div className="contact-map">
            <iframe
              title="Google Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d28506.07926338989!2d85.25291887043007!3d26.736080862151468!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39ecbfe030119f3d%3A0xef4e19847ff0e932!2sBairgania%2C%20Bihar!5e0!3m2!1sen!2sin!4v1782133744887!5m2!1sen!2sin"
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </div>

        </div>
      </section>

      {/* ----------------- Contact Form Start ----------------- */}
      <section className="contact-form-section">
        <div className="container">
          <h2 className="form-title">Send Message</h2>

          <form className="contact-form">
            <div className="form-row">
              <input type="text" placeholder="Name" />
              <input type="email" placeholder="Email" />
              <input type="text" placeholder="Website" />
            </div>

            <textarea placeholder="Your Message"></textarea>

            <div className="form-btn">
              <button type="submit">SEND COMMENT</button>
            </div>
          </form>
        </div>
      </section>
    </>
  );
};

export default Contact;
